import React, { useState } from "react";
import { getDatabase, ref, set, push, child } from "firebase/database";
import { VscChromeClose } from "react-icons/vsc";
import AddQuizComponent from "./AddQuizComponent";

const AddQuestionComponent = (props) => {
  // for question record
  const [questionName, setQuestionName] = useState("");
  const [text, setText] = useState("");
  const [correctOption, setCorrectOption] = useState("");
  const [options, setOptions] = useState([]);
  const [interviewerName, setInterviewerName] = useState("");
  const [interviewerTitle, setInterviewerTitle] = useState("");
  const [assetURL, setAssetURL] = useState("");
  const [explanationAssetURL, setExplanationAssetURL] = useState("");

  const [inputFieldsError, setInputFieldsError] = useState("");

  const emptyInputStringsValidation = () => {
    return (
      // questionName != "" && // ADD AUTO GENERATED ID
      text != "" &&
      correctOption != "" &&
      options.length >= 1 &&
      interviewerName != "" &&
      interviewerTitle != "" &&
      assetURL != "" &&
      explanationAssetURL != ""
    );
  };

  const writeData = (
    questionName,
    text,
    correctOption,
    options,
    interviewerName,
    interviewerTitle,
    assetURL,
    explanationAssetURL
  ) => {
    const db = getDatabase();
    const newQuestionKey = push(child(ref(db), "questions")).key;

    if (emptyInputStringsValidation()) {
      set(ref(db, "questions/" + newQuestionKey), {
        text: text,
        correctOption: parseFloat(correctOption),
        options: options,
        interviewerName: interviewerName,
        interviewerTitle: interviewerTitle,
        assetURL: assetURL,
        explanationAssetURL: explanationAssetURL,
      });
      setInputFieldsError(emptyInputStringsValidation());

      props.setModalIsOpen(false);
      setQuestionName("");
      setText("");
      setCorrectOption("");
      setOptions([]);
      setInterviewerName("");
      setInterviewerTitle("");
      setAssetURL("");
      setExplanationAssetURL("");

      if (props.inQuiz) {
        props.setQuestions([...props.questions, newQuestionKey]);
        console.log(props.questions);
        props.reducer();
      }
    } else {
      setInputFieldsError(emptyInputStringsValidation());
    }
  };

  return (
    <div className="question-list-modal-body">
      <div className="modal-title">
        {props.inQuiz ? (
          <button onClick={() => props.setModalIsOpen(false)}>Back</button>
        ) : (
          ""
        )}
        <h1>Add question</h1>
        <button
          className="close-modal-btn"
          onClick={() => props.setModalIsOpen(false)}
        >
          <VscChromeClose size={"20px"} color="grey" />
        </button>
      </div>
      <div className="question-list-modal-input-fields">
        {/* <input 
          className="modal-input"
          placeholder="Question Title"
          onChange={(e) => {
            setQuestionName(e.target.value);           // ADD AUTO GENERATED ID
          }}
        /> */}
        <input
          className="modal-input"
          placeholder="Text"
          onChange={(e) => {
            setText(e.target.value);
          }}
        />
        <input
          className="modal-input"
          placeholder="Correct Option"
          onChange={(e) => {
            setCorrectOption(e.target.value);
          }}
        />
        <input
          className="modal-input"
          placeholder="Options"
          onChange={(e) => {
            setOptions(e.target.value.split(", "));
          }}
        />
        <input
          className="modal-input"
          placeholder="Interviewer Name"
          onChange={(e) => {
            setInterviewerName(e.target.value);
          }}
        />
        <input
          className="modal-input"
          placeholder="Interviewer Title"
          onChange={(e) => {
            setInterviewerTitle(e.target.value);
          }}
        />
        <input
          className="modal-input"
          placeholder="Asset URL"
          onChange={(e) => {
            setAssetURL(e.target.value);
          }}
        />
        <input
          className="modal-input"
          placeholder="Explanation Asset URL"
          onChange={(e) => {
            setExplanationAssetURL(e.target.value);
          }}
        />
      </div>
      <div style={{ display: "flex", marginTop: "8%", alignItems: "center" }}>
        <button
          className="submit-button"
          onClick={() =>
            writeData(
              questionName,
              text,
              correctOption,
              options,
              interviewerName,
              interviewerTitle,
              assetURL,
              explanationAssetURL
            )
          }
        >
          Add question
        </button>
        <p className="error-message">
          {inputFieldsError === "" ? "" : "*Each field is required"}
        </p>
      </div>
    </div>
  );
};

export default AddQuestionComponent;
